import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetCompanyReceipts } from '../../../../../redux/actions/company'
import EmptyTableView from '../../../../universal/empty-table'
import InvoicesTable from './table'
import { TableLoader } from '../../../../library/table-loader'
import { UpperRow } from '../../../../library/upper-row'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const [searchQuery, setSearchQuery] = useState(null);
    const loading = useSelector(state => state.company.fetchReceipts.loading)
    const error = useSelector(state => state.company.fetchReceipts.error)
    const allReceipts = useSelector(state => state.company.receipts) 

    const companyDetailsLoading = useSelector(state => state.company.fetchDetails.loading)
	
    const searchLibrary = e => {
        setSearchQuery(e.target.value)
    }

    useEffect(() => {
        if(error){
            dispatch(resetCompanyReceipts())
        }
    }, loading, error)
    
    return(
       <div className="dashboard-company-payments-container">
            <div className="inner-dashboard-company-payments-container">
                <UpperRow title="Utførte betalinger"/>
                <InvoicesTable searchQuery={searchLibrary}/>
                {loading || companyDetailsLoading ? <TableLoader/>:null}
                {!loading && !companyDetailsLoading && allReceipts.length === 0 ? <EmptyTableView title="Ingen betalingshistorikk" description="Du har ingen betalingshistorikk å vise, ta kontakt med oss dersom du tror at dette kan være en feil så kan vi hjelpe deg."/>:null}
            </div>
       </div>
    )
}

export default Index
